import "./loginStyle.css"
import * as React from 'react';
import { SignInPage } from '@toolpad/core/SignInPage';
import { AppProvider } from '@toolpad/core/AppProvider';
import { svSE } from '@mui/material/locale';
import {useTheme} from "@mui/material/styles";
import { ReactComponent as Logo } from '../omradeskollen_logga.svg';



const providers = [{ id: 'nodemailer', name: 'Email' }];
const API_BASE = String(process.env.REACT_APP_API_BASE_URL || 'https://api.xn--omrdeskollen-vcb.nu').replace(/\/+$/, '');
const MAGIC_LOGIN_ENDPOINT = String(process.env.REACT_APP_MAGIC_LOGIN_ENDPOINT || `${API_BASE}/magic`).trim();


const BRANDING = {
    logo: (
        <div className="logoContainer2">
        <Logo sx={{width:'30px'}}/>
        </div>
    ),
    title: 'hempejl',
};




export default function LoginForm() {
    const theme = useTheme(svSE);

    const parseJsonResponse = async (response) => {
        const text = await response.text();
        if (!text) return {};
        try {
            return JSON.parse(text);
        } catch (error) {
            return { raw: text };
        }
    };

    const signIn = async (_provider, formData) => {
        const email = String(formData?.get('email') || '').trim();
        if (!email) {
            return { error: 'Enter your email address.' };
        }

        try {
            const response = await fetch(MAGIC_LOGIN_ENDPOINT, {
                method: 'POST',
                body: JSON.stringify({ email }),
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            const payload = await parseJsonResponse(response);

            if (!response.ok) {
                const message = payload?.error || payload?.message || response.statusText || 'Login failed';
                return { error: `${response.status}: ${message}` };
            }

            return { success: payload?.success || 'Check your email for a magic link.' };
        } catch (error) {
            console.error('Failed to call magic login endpoint', error);
            return { error: 'Could not reach login API. Check the API URL/CORS configuration.' };
        }

    };


    return (
        <AppProvider theme={theme} branding={BRANDING}>
            <SignInPage signIn={signIn} providers={providers}  sx={{ minHeight: '25vh', boxShadow:'none'}}
                        slots={{
                title: () => (
                        "Logga in till hempejl"
                ),
                subtitle: () => (
                   ""
                ),
            }}/>
        </AppProvider>
    );
}
